import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";

const PHONE = "338 734 8963";
const EMAIL = "asilonidoperamore@gmail.com";
const QUERY = "Via Strasburgo 3/b, San Donato Milanese 20097";
const MAP_SRC = "https://maps.google.com/maps?q=" + encodeURIComponent(QUERY) + "&t=&z=15&ie=UTF8&iwloc=&output=embed";

const cards = [
  { icon: MapPin, label: "Indirizzo", value: "Via Strasburgo 3/b, San Donato Milanese (MI) — Torri Lombarde 20097", color: "text-sky-600 bg-sky-100", href: `https://maps.google.com/maps?q=${encodeURIComponent(QUERY)}`, testid: "contact-address" },
  { icon: Phone, label: "Telefono", value: PHONE, color: "text-emerald-600 bg-emerald-100", href: `tel:${PHONE.replace(/\s/g, "")}`, testid: "contact-phone" },
  { icon: Mail, label: "Email", value: EMAIL, color: "text-rose-600 bg-rose-100", href: `mailto:${EMAIL}`, testid: "contact-email" },
  { icon: Clock, label: "Orari", value: "Dal Lunedì al Venerdì, dalle 8:00 alle 18:00", color: "text-amber-600 bg-amber-100", testid: "contact-hours" },
];

export const Contatti = () => (
  <section id="contatti" data-testid="contatti-section" className="py-20 sm:py-28 scroll-mt-24 bg-[#f7f0e3]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <p className="text-sm font-800 uppercase tracking-[0.2em] text-sky-500">Contatti e Orari</p>
        <h2 className="mt-2 font-heading text-3xl sm:text-4xl md:text-5xl font-700 text-slate-800">Vieni a trovarci</h2>
      </div>

      <div className="mt-12 grid lg:grid-cols-2 gap-8 items-stretch">
        <motion.div initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="relative rounded-[2rem] overflow-hidden shadow-xl border border-slate-100 min-h-[380px]">
          <iframe title="Mappa - Asilo Per Amore" data-testid="map-iframe" src={MAP_SRC}
            className="w-full h-full min-h-[380px] border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          <a href={`https://maps.google.com/maps?q=${encodeURIComponent(QUERY)}`} target="_blank" rel="noopener noreferrer"
            data-testid="map-directions"
            className="absolute bottom-5 left-5 inline-flex items-center gap-2 rounded-full bg-white px-5 py-3 font-700 text-slate-800 shadow-lg hover:-translate-y-0.5 transition-all">
            <Navigation className="h-4 w-4 text-sky-500" /> Come arrivare
          </a>
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="grid sm:grid-cols-2 gap-5">
          {cards.map((c) => {
            const W = c.href ? "a" : "div";
            return (
              <W key={c.label} data-testid={c.testid}
                {...(c.href ? { href: c.href, target: c.label === "Indirizzo" ? "_blank" : undefined, rel: "noopener noreferrer" } : {})}
                className="rounded-[1.5rem] bg-white border border-slate-100 p-6 hover:-translate-y-1 hover:shadow-xl transition-all flex flex-col">
                <span className={`grid place-items-center h-12 w-12 rounded-2xl ${c.color}`}><c.icon className="h-6 w-6" /></span>
                <p className="mt-4 text-sm font-800 uppercase tracking-widest text-slate-400">{c.label}</p>
                <p className="mt-1 font-700 text-slate-800 break-words">{c.value}</p>
              </W>
            );
          })}
        </motion.div>
      </div>
    </div>
  </section>
);
